import React, { useState, useEffect } from 'react';
import useWindowDimensions from "../../hooks/useWindowDimension";
import {AUTH_PERMISSION, PERMISSION_LEVEL_COMPONENT, TABLET_WIDTH} from "../../constant";
import { useTranslation } from 'react-i18next';
import {ErrorHandler} from "../ErrorHandler";
import {getRoles, makeSmallStringInTabletVersion} from "./rolesUtil";
import ComponentPermissionItem from "./ComponentPermissionItem";
import PermissionsListElem from "./PermissionsListElem";
import {ChevronIcon} from "../../appearence/icons/chevron_icon";

const RolesTable = ({initialRolesPermissions}) => {
    const { i18n } = useTranslation();
    const [rolesPermissions, setRolesPermissions] = useState([]);
    useEffect(() => {
        setRolesPermissions(initialRolesPermissions);
    }, [initialRolesPermissions]);
    const handleSetRoleIsOpen = (index) => {
        rolesPermissions[index].isOpen = !rolesPermissions[index].isOpen;
        setRolesPermissions([...rolesPermissions]);
    };

    const { width } = useWindowDimensions();
    try {
        return (
            <div className="users__table-wrapper">
                <table className="block__table users__table users__table-roles">
                    <thead>
                    <tr className="users__table-header users__table-roles-header">
                        <th className="users__table-item users__table-item_sticky">
                            {width <= TABLET_WIDTH ?
                                i18n.t('app.page.appRole.businessObjectAndRoles.object')
                                :
                                <>
                                    <span className="users__table-item_capitalize">{i18n.t('app.page.appRole.businessObjectAndRoles.businessObject')}</span>
                                    /
                                    <span className="users__table-item_capitalize">{i18n.t('app.page.appRole.businessObjectAndRoles.roles')}</span>
                                </>}
                        </th>
                        {getRoles().map((it, index) => (
                            <th className="users__table-item users__table-item_sticky" key={index + 'header'}>
                                {width <= TABLET_WIDTH ?
                                    makeSmallStringInTabletVersion(i18n.t(`appRoles.scheme.userRoles.${it.code}`), i18n)
                                    :
                                    i18n.t(`appRoles.scheme.userRoles.${it.code}`)}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {rolesPermissions.map((permission, index) => (
                        <React.Fragment key={index + 'rolesList'}>
                            {permission.targetName !== AUTH_PERMISSION && <tr className={permission.isOpen ? "" : "users__table-roles-row"} key={permission.entryPoint} >
                                <td className="users__table-item users__table-title" onClick={() => permission.level !== PERMISSION_LEVEL_COMPONENT ? handleSetRoleIsOpen(index) : null}>
                                    {width <= TABLET_WIDTH ?
                                        makeSmallStringInTabletVersion(i18n.t(`app.page.appRole.businessObjectAndRoles.${permission.targetName}`), i18n)
                                        :
                                        i18n.t(`app.page.appRole.businessObjectAndRoles.${permission.targetName}`)}
                                </td>
                                {getRoles().map((role, indexItem) => {
                                    return (
                                        <td key={role.id} className="users__table-item">
                                            {permission.level === PERMISSION_LEVEL_COMPONENT ?
                                                <ComponentPermissionItem role={role} permission={permission}/>
                                                : indexItem === 0 ?
                                                    <span onClick={() => permission.level !== PERMISSION_LEVEL_COMPONENT ? handleSetRoleIsOpen(index) : null}>
                                                            <ChevronIcon nameOfClass={permission.isOpen ? 'users__table-icon_active' : 'users__table-icon'} />
                                                        </span>
                                                    :
                                                    null}
                                        </td>
                                    );
                                })}

                            </tr>}
                            {permission.isOpen ? <PermissionsListElem rolePermission={permission} /> : ''}
                        </React.Fragment>))}
                    </tbody>
                </table>
            </div>
        );
    } catch(err) {
        console.log(err);
        return <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')}/>;
    }
};

export default RolesTable;
